<template>
	<div class="page solution solutionItem">
		<TopSubMenu
			:menu="$store.state.gnb.menuList[1].subCategory[1].subMenu"
		></TopSubMenu>

		<!-- solutions -->
		<section class="secWrap">
			<div class="topBgWrap" :style="topBgStyle"></div>
			<div class="pageContentWrap">
				<div class="pageTitleWrap">
					<p class="subTxt">{{ subTitle }}</p>
					<h2 class="titleTxt">{{ title }}</h2>
					<div class="imgWrap" v-if="mainImg">
						<img :src="mainImg" alt="두손소프트 솔루션 패키지 이미지" />
					</div>
				</div>
				<!-- color box : 버튼 & 소개문구 -->
				<div class="pageHeaderBoxWrap" :style="pageHeaderStyle">
					<!-- 소개문구 -->
					<p class="pageHeaderTxt" v-html="explanation"></p>
					<!-- 버튼 리스트 -->
					<div class="pageHeaderBtns bottom right">
						<template v-for="(item, index) in btns">
							<b-button
								v-if="!(windowWidth <= 1025 && item.title === '개발자 가이드')"
								class="btnLink"
								tag="a"
								:key="index"
								:href="item.url"
								target="_blank"
								type="is-light"
								rounded
								outlined
								>{{ item.title }}</b-button
							>
						</template>
					</div>
				</div>
				<div class="pageInnerContentHtmlWrap">
					<!-- 컴포넌트 및 html 자리 -->
					<!-- 특징 -->
					<div class="pageInnerContent">
						<div class="boardInfoWrap">
							<h3 class="mainTitle">특징</h3>
							<div class="imgListWrap">
								<ul class="imgList">
									<li class="imgListItem">
										<img
											:src="characteristicImgSrc"
											alt="HTML5 기반의 순수 Web Solution"
										/>
									</li>
								</ul>
							</div>
							<div class="infoTxtWrap">
								<ul class="infoTxtList">
									<li
										v-for="(item, idx) in characteristicList.arr"
										:key="idx"
										class="infoTxtListItem withHyphen"
										v-html="item"
									></li>
								</ul>
							</div>
						</div>
					</div>
					<!-- 주요특징 -->
					<div class="pageInnerContent" v-if="mainFunction.length > 0">
						<section>
							<h3 class="mainTitle">주요특징</h3>
							<div
								class="boardList"
								:class="
									mainFunction.length > 3 && this.mainFunction.length % 3 == 0
										? 'column3'
										: 'column2'
								"
							>
								<template v-for="(item, idx) in mainFunction">
									<div class="boardListItem" :key="idx">
										<img
											:src="$store.state.dataUrl + item.img"
											:alt="`주요특징 이미지 ${idx + 1}`"
										/>
										<div class="boardListTxt">
											<h4 class="boardListTitle">{{ item.title }}</h4>
											<span class="boardListCont" v-html="item.detail"></span>
										</div>
									</div>
								</template>
							</div>
						</section>
					</div>
					<!-- 활용분야 -->
					<div
						class="pageInnerContent"
						v-if="UtilizationField.length > 0 && useDetail !== ''"
					>
						<div class="pageInnerContent">
							<div
								class="boardInfoWrap halfColumn"
								:class="
									UtilizationField.length == 1 ? 'fullColumn' : 'halfColumn'
								"
							>
								<h3 class="mainTitle">활용 분야</h3>
								<div class="imgListWrap" v-if="UtilizationField.length > 0">
									<ul class="imgList">
										<li
											v-for="(item, idx) in UtilizationField"
											:key="idx"
											class="imgListItem"
										>
											<img
												:src="$store.state.dataUrl + item.img"
												:alt="`활용 분야 이미지 ${idx + 1}`"
											/>
										</li>
									</ul>
								</div>
								<div class="infoTxtWrap" v-if="useDetail !== ''">
									<div class="infoTxt" v-html="useDetail"></div>
								</div>
							</div>
						</div>
					</div>
					<!-- 갤러리 -->
					<div class="pageInnerContent" v-if="gallery.length > 0">
						<div class="typeBoardWrap">
							<h3 class="mainTitle">갤러리</h3>
							<ul class="imgList">
								<li
									v-for="(item, idx) in gallery"
									:key="idx"
									class="typeBoardImg"
									:class="galleryClass"
								>
									<img
										:src="$store.state.dataUrl + item.img"
										:alt="`솔루션 갤러리 이미지 ${idx + 1}`"
									/>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
		<Footer />
	</div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import TopSubMenu from "../../components/TopSubMenu";
import Footer from "../../components/Footer";

export default {
	name: "solutions",
	components: {
		TopSubMenu,
		Footer
	},
	data() {
		return {
			bgColor: "", // PageHeader bgColor
			bgImg: "", // topBgStyle bgImg
			mainImg: "", // 솔루션 패키지 이미지
			title: "", // 솔루션 타이틀 (ex: "TS Web Scanner")
			subTitle: "", // 서브 타이틀 (ex: "쉽고 빠르게 찍고 편집하고 보내Go")
			explanation: "", // 설명 (ex: "자동으로 이미지의 외곽선을 추출하고 ~~" )
			characteristic: "", // 특징 text
			gallery: [], // 갤러리 arr
			btns: [], // 링크 버튼 arr
			mainFunction: [], // 주요 특징 arr (img + title + detail)
			useDetail: "", // 활용 분야 text
			UtilizationField: [], // 활용분야 이미지 arr
			windowWidth: window.innerWidth
		};
	},
	computed: {
		topBgStyle: function() {
			return {
				backgroundImage: "url(" + this.bgImg + ")",
				backgroundSize: "cover",
				backgroundPosition: "center center"
			};
		},
		pageHeaderStyle: function() {
			return {
				backgroundColor: this.bgColor,
				backgroundSize: "cover",
				backgroundPosition: "center center"
			};
		},
		// 특징 데이터 변경
		characteristicList: function() {
			const arr = this.characteristic.split("\n");
			return {
				arr
			};
		},
		galleryClass: function() {
			return {
				col3: this.gallery.length >= 3 && this.gallery.length % 2 !== 0,
				col2: this.gallery.length >= 2 && this.gallery.length % 2 === 0
			};
		},
		filteredBtns() {
			// 해상도 1025 이하일 때 개발자 가이드 버튼 숨김 처리
			return this.btns.filter(
				item => !(this.windowWidth <= 1025 && item.title === "개발자 가이드")
			);
		},
		characteristicImgSrc() {
			console.log("타이틀:" + this.title);
			return this.title === "Hyper Excel Platform"
				? require("@/assets/images/img-solution-hxp.jpg")
				: require("@/assets/images/img-solution-common-info@2x.png");
		}
	},
	mounted() {
		// data load
		// soltion > twosonSolution list data load
		this.$axios
			.get(
				`${this.$store.state.dataUrl}/twosonSolution?no=${this.$route.params.id}`
			)
			.then(response => {
				console.log("twosonSolutionData > solutions : ", response.data);
				let bgColor = response.data.color;
				let bgImg = response.data.bgImg;
				let mainImg = response.data.mainImg;
				let title = response.data.title;
				let subTitle = response.data.subTitle;
				let explanation = response.data.explanation;
				let characteristic = response.data.content.characteristic;
				let gallery = response.data.content.gallery;
				let btns = response.data.url;
				let mainFunction = response.data.content.mainFunction;
				let useDetail = response.data.content.useDetail;
				let UtilizationField = response.data.content.UtilizationField;

				if (response.data) {
					// 설명 (ex: "자동으로 이미지의 외곽선을 추출하고 ~~" )
					this.explanation = explanation;

					// 솔루션 패키지 이미지
					this.mainImg = this.$store.getters.getUrlPrefix + mainImg;

					// 솔루션 타이틀 (ex: "TS Web Scanner")
					this.title = title;

					// 서브 타이틀 (ex: "쉽고 빠르게 찍고 편집하고 보내Go")
					this.subTitle = subTitle;

					// topBgStyle bgImg
					this.bgImg = this.$store.getters.getUrlPrefix + bgImg;

					// PageHeader bgColor
					this.bgColor = bgColor;

					// 특징
					this.characteristic = characteristic;

					// 갤러리
					this.gallery = gallery;

					// 상단 버튼 리스트 (ex: "체험하기")
					this.btns = btns;

					// 주요 특징
					this.mainFunction = mainFunction;

					// 활용분야
					this.useDetail = useDetail;
					this.UtilizationField = UtilizationField;
				}
			})
			.catch(error => {
				console.log(
					"* twosonSolutionData > solutions error : ",
					error.response
				);
				this.$router.push({ name: "errorPage" });
			});

		window.addEventListener("resize", this.onWinResize);
		this.onWinResize();
	},
	created() {
		AOS.init({
			duration: 600,
			easing: "ease-in-sine",
			delay: 100
		});
	},
	destroyed() {
		window.removeEventListener("resize", this.onWinResize);
	},
	methods: {
		onWinResize() {
			this.windowWidth = window.innerWidth;
		}
	}
};
</script>
